<template>
  <div class="row m-0 content">
    <div class="col-12 px-0 price-per-day">{{ this.rate }} per day</div>
    <div class="col-12 px-0 cannot-book"><i class="far fa-times-circle mr-2"></i>Cannot Book Online</div>
    <div class="col-12 px-0 cannot-reserve"><i class="far fa-times-circle mr-2"></i>Cannot Reserve in Advance</div>
    <div v-if="this.desktop" class="col-12 alternative-link">You can reserve cheaper parking online at {{ this.upperCode }} by booking at other parking lots <a :href="this.link" class="text-link text-link--lg">here</a>.</div>
  </div>
</template>

<script>
export default {
  props: {
    desktop: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    rate: String,
    isCruisePort: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    link() {
      const suffix = this.isCruisePort ? '/port-parking' : '/airport-parking';
      return '/' + this.code.toLowerCase() + suffix;
    },
    upperCode() {
      return this.code?.toUpperCase()
    }
  }
}
</script>